import { useState, useEffect, useRef } from 'react';
import { QueryBuilder } from 'react-querybuilder';


import useStateRef from "react-usestateref";

import { Icon as Iconify } from '@iconify/react';
import 'react-querybuilder/dist/query-builder.css';

import '../Others/QueryBuilderStyles.css';

import { FormProvider } from 'react-hook-form';
import { useLocation } from 'react-router';

import { ClearIcon } from '@mui/x-date-pickers';
import { Select, MenuItem, Button, Tooltip, IconButton, Checkbox, TextField, Autocomplete, Box, Stack, FormControl, Divider } from '@mui/material';
import schemedefinationService from '../../../services/schemedefination.service';


import RetailerValueEditor from '../Others/RetailerQueryBuilderValueEditor';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import { useSchemeStore } from '../schemeStore';
import { useSchemeSavePermission } from '../utils/useSchemeSavePermission';



const SchemeRetailer = () => {   // NOSONAR
    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;
    const canSaveScheme = useSchemeSavePermission(isCopyScheme);
    const {
        schemeDetails,
        tabValue,
        prevTabValue,
        setRetailerData,
        updateScheme,
        addScheme
    } = useSchemeStore();
    const initialLoading = useRef(true);


    const [classificationData, setClassificationData] = useState(null);
    const [subClassificationData, setSubClassificationData] = useState({});
    const [classification, setClassification] = useState(null);
    const [selectedClassification, setSelectedClassification] = useState(null);

    const [dataTypes, setDataTypes] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);





    const [alertType, setAlertType] = useState(''); // NOSONAR
    const [alertMessage, setAlertMessage] = useState(''); // NOSONAR
    const [showAlert, setShowAlert] = useState(false); // NOSONAR





















    const [initialQuery, setInitialQuery, initialQueryRef] = useStateRef(null);

  





















































    useEffect(() => {
        const fetchData = async () => {

            //  showLoading()
            //  setLoading(true)
            try {
                const itemData = schemeDetails?.Retailer;

                // Extract unique subclassification names
                const subclassifications = new Set(
                    itemData
                        .flatMap((filterData) => filterData.Details)
                        .flatMap((detail) =>
                            Object.keys(detail)
                                .filter((key) => key !== 'ConditionalStatement')
                                .map((key) => key.split('-').pop())
                        )
                );

                // Fetch data for each subclassification concurrently
                const subclassificationPromises = Array.from(
                    subclassifications
                ).map(async (item) => {
                    const payload = {
                        filterApplicationOn: 'Retailer',
                        filterClassification: item,
                        IsException: false,
                        SchemeId: 0,
                    };

                    const schemeDefinationInstance = await schemedefinationService;
                    const response = await schemeDefinationInstance.GetSchemeFilterSubClassificationRetailer(
                        payload
                    );

                    if (response.status === 200) {
                        return { [item]: response.data };
                    }

                    console.error(
                        'Error while fetching subclassification data. Status:',
                        response.status,
                        'Error Message:',
                        response.data
                    );
                    return null;

                });

                const subclassificationResponses = await Promise.all(
                    subclassificationPromises
                );

                // Process and merge subclassification data
                const newSubClassificationData = {};
                const newDataTypes = {};

                subclassificationResponses.forEach((response) => {
                    if (response) {
                        Object.entries(response).forEach(([key, value]) => {
                            newSubClassificationData[key] = value?.DefaultValues || [];
                            newDataTypes[key] = value?.DataType || '';
                        });
                    }
                });


                setSubClassificationData(newSubClassificationData);
                setDataTypes(newDataTypes);

                // ... Your logic for transforming itemData to QueryBuilder structure ...

                let queryBuilderStructure;

                if (itemData.length > 0) {
                    queryBuilderStructure = transformItemDataToQueryBuilder(itemData[0]?.Details);
                } else {
                    return;
                }

                setInitialQuery(queryBuilderStructure);
                setGeneratedQuery(queryBuilderStructure);
            } catch (error) {
                console.error('Error:', error);
            } finally {


                // setLoading(false)
            }
        };

        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]);


    const transformItemDataToQueryBuilder = (data) => {  // NOSONAr
        const cdn = data[0]?.ConditionalStatement;

        const extractFieldDetails = (field) => {
            const match = field.match(/(\d+)!([A-Za-z]+):([A-Za-z0-9\-_]+)/);  // NOSONAR
            if (!match) {
                return null;
            }
            const [, index, operator, fieldName] = match;
            return { index, operator, fieldName };
        };

        const buildRule = (fieldIndex, operator, fieldData) => {
            const rule = {
                field: fieldIndex,
                operator: operator === "NotIN" ? "NotIN" : operator,
                valueSource: "value",
                value: fieldData,
            };
            return rule;
        };

        const parseCondition = (condition) => {
            // Adjusted regex to ignore empty tokens
            const tokens = condition.match(/\S+/g); // Matches non-whitespace sequences
            let index = 0;

            const parseExpression = () => {
                const rules = [];
                let combinator = 'and';

                while (index < tokens.length) {
                    const token = tokens[index];

                    if (token === ')') {
                        index += 1;
                        break;
                    } else if (token === '(') {
                        index += 1;
                        const subExpression = parseExpression();
                        rules.push(subExpression); // Save the parsed sub-expression
                    } else if (token === 'AND' || token === 'OR') {
                        combinator = token.toLowerCase();
                        index += 1;
                    } else {
                        const fieldDetails = extractFieldDetails(token);
                        if (fieldDetails) {
                            const { index: fieldIndex, operator, fieldName } = fieldDetails;
                            const fieldData = data[0][`${fieldIndex}!${fieldName}`];

                            const rule = buildRule(fieldName, operator, fieldData);
                            rules.push(rule);
                        }
                        index += 1;
                    }
                }

                const expression = { combinator, rules };
                return expression;
            };

            return parseExpression();
        };

        return parseCondition(cdn).rules[0];
    };
















































































































    // Fetch classifications on mount
    useEffect(() => {

        const getClassification = async () => {

            // setLoading(true)

            try {

                //  showLoading()
                const schemeDefinationInstance = await schemedefinationService;
                const response = await schemeDefinationInstance.SchemeRetailer();

                if (response.status === 200) {
                    setClassificationData(response.data);
                    setClassification(
                        response.data[0].DefaultValues?.map((item) => ({
                            name: item.SchemeFilterClassificationId,
                            label: item.SchemeFilterClassification,
                        }))
                    );


                } else {
                    console.error(
                        'Error while fetching classification data. Status: ',
                        response.status,
                        'Error Message:',
                        response.data
                    );
                }


            } catch (error) {


                console.error('Error:', error);
            } finally {

                // setLoading(false)
                initialLoading.current = false;
            }
        };

        getClassification();
    }, [schemeDetails]);

    // Fetch subclassifications when selectedClassification changes



















































































































    const operators = [
        { name: 'IN', label: 'IN' },
        { name: 'NotIN', label: 'Not IN' },
    ];

    const fields = classification?.map((item) => ({
        name: `${classificationData[0]?.TableName}-${item.label}`,
        label: item.label,
    }));

    const operatorOptions = operators.map((op) => ({
        name: op.name,
        label: op.label,
    }));


    const getUsedFieldsInGroup = (rules) => {
        const used = new Set();
        if (Array.isArray(rules)) {
            rules.forEach(rule => {
                if (rule && rule.field) {
                    used.add(rule.field);
                }
            });
        }
        return used;
    };

    const onAddRule = (rg, parentPath) => {
        const newQuery = JSON.parse(JSON.stringify(initialQuery));

        let targetGroup = newQuery;
        parentPath.forEach(idx => {
            targetGroup = targetGroup.rules[idx];
        });

        // Get available fields for THIS GROUP
        const usedFields = getUsedFieldsInGroup(targetGroup.rules);
        const availableFields = fields.filter(f => !usedFields.has(f.name));

        // Use first available field or fallback to first field
        const newField = availableFields[0]?.name || fields[0].name;


        const newRule = {
            field: newField,
            operator: operators?.[0]?.name || 'IN',
            value: newField === 'accountValue' ? 0 : '' // Default values
        };

        targetGroup.rules = [...targetGroup.rules, newRule];
        handleQueryChange(newQuery);
    };

















    const combinators = [
        { name: 'and', label: 'AND' },
        { name: 'or', label: 'OR' },
    ];

    const [generatedQuery, setGeneratedQuery] = useState({});

    const handleQueryChange = (newQuery) => {
        setInitialQuery(newQuery);
        setGeneratedQuery(newQuery);
    };


    const newQueryFormat = (query) => { // NOSONAR
         //  console.log("!!! Initial query:", query);

        const result = {};
        let conditionalStatement = "";
        let counter = 1;
        const fieldValues = {};
        let errMsg = null;

        function processRules(rules, parentCombinator = null) {
             //  console.log("!!! Processing rules:", rules, "Parent Combinator:", parentCombinator);
            let localStatement = "";
            rules.forEach((rule, index) => {
                 //  console.log(`!!! Processing rule #${index + 1}:`, rule);
                if (rule.rules) {
                     //  console.log("!!! Found nested rule group:", rule.rules);
                    const nestedStatement = processRules(rule.rules, rule.combinator);
                     //  console.log("!!! Nested conditional statement:", nestedStatement);
                    localStatement += `( ${nestedStatement} )`;
                } else {
                    const key = `${counter}!${rule.field}`;
                     //  console.log(`!!! Generated key: ${key}`);

                    if (
                        !Array.isArray(rule?.value) ||
                        (Array.isArray(rule?.value) && (rule?.value.length === 0 || rule?.value[0] === ''))
                    ) {

                        setErrorMessage("Please select values in all rules!");
                        setRetailerData("error");
                        throw new Error("Please select values in all rules!");

                        // return;
                    }
                    result[key] = rule.value.map(item => {
                         //  console.log("!!! Mapping value item:", item);
                        if (typeof item === 'string') {
                            return item;
                        }
                        if (typeof item === 'object' && item !== null) { // NOSONAR
                            const keyWithId = Object.keys(item).find(keyy => keyy.toLowerCase().includes("id"));
                             //  console.log("!!! Object key with ID found:", keyWithId);
                            return keyWithId ? item[keyWithId] : Object.values(item)[0];
                        }
                        return null;
                    }).filter(item => item !== null);

                     //  console.log(`!!! Result[${key}]:`, result[key]);

                    localStatement += `${counter}!${rule.operator}:${rule.field}`;
                     //  console.log("!!! Current local statement:", localStatement);

                    if (!fieldValues[rule.field]) {
                        fieldValues[rule.field] = { IN: [], NotIN: [] };
                         //  console.log(`!!! Initialized fieldValues for ${rule.field}`);
                    }

                    fieldValues[rule.field][rule.operator] = fieldValues[rule.field][rule.operator].concat(rule.value);
                     //  console.log(`!!! Updated fieldValues[${rule.field}][${rule.operator}]:`, fieldValues[rule.field][rule.operator]);

                    counter += 1;
                }

                if (index < rules.length - 1) {
                    const combinator = (parentCombinator || query.combinator).toUpperCase();
                    localStatement += ` ${combinator} `;
                     //  console.log(`!!! Appended combinator '${combinator}'`);
                }
            });
             //  console.log("!!! Returning local statement:", localStatement);
            return localStatement;
        }

        conditionalStatement = processRules(query.rules);
         //  console.log("!!! Final conditionalStatement before NOT check:", conditionalStatement);

        if (query.not) {
            conditionalStatement = `NOT ( ${conditionalStatement} )`;
             //  console.log("!!! Negated conditional statement:", conditionalStatement);
        }

        result.ConditionalStatement = `( ${conditionalStatement} )`;
         //  console.log("!!! Final result with ConditionalStatement:", result);

        // Conflict check for IN and NOT IN
        Object.entries(fieldValues).forEach(([field, operatorValues]) => {
            const inValues = new Set(operatorValues.IN);
            const notInValues = new Set(operatorValues.NotIN);
            const conflictingValues = [...inValues].filter(x => notInValues.has(x));
             //  console.log(`!!! Checking conflicts for field ${field}:`, { inValues, notInValues, conflictingValues });

            if (conflictingValues.length > 0) {
                 //  console.log("!!! subClassificationData: ", subClassificationData);
                 //  console.log("!!! selectedClassification: ", selectedClassification);
                 //  console.log("!!! subClassificationData[selectedClassification]: ", subClassificationData[selectedClassification]);

                errMsg = `Same item(s) selected for ${field.split('-').pop()} in IN and NOT IN:  ${conflictingValues.map(value => {
                    const matchingItem = subClassificationData[selectedClassification].find(item => Object.values(item).includes(value));
                    if (matchingItem) {
                        const nameKey = Object.keys(matchingItem).find(key => !key.toLowerCase().includes("id"));
                        return matchingItem[nameKey] || value;
                    }
                    return value;
                }).join(', ')}`;
                 //  console.log("!!! Error message set due to conflict:", errMsg);
            }
        });

        const values = Object.values(result);
         //  console.log("!!! Result object values:", values);
        const hasEmptyValue = values.some(value => (Array.isArray(value) && value.length === 0) || value === '');
         //  console.log("!!! Has empty value?", hasEmptyValue);

        if (values.length === 2 && hasEmptyValue) {
             //  console.log("!!! Returning [] due to empty rule and only 2 keys in result");
            return [];
        }

        if (result?.ConditionalStatement?.length === 0) {
            return [];
        }

        if (result.ConditionalStatement === '(  )') {
   
            return [];
        }

        const emptyFields = Object.entries(result).filter(([key, value]) => value === "").map(([key]) => key.split("!").pop());
        if (emptyFields.length > 0) {
            errMsg = `Please select values in all rules!`;
             //  console.log("!!! Empty fields found:", emptyFields, "Error message:", errMsg);
            setErrorMessage(errMsg);
            return ['error', errMsg];
        }

        if (errMsg) {
             //  console.log("!!! Final error found:", errMsg);
            setErrorMessage(errMsg);
            return ['error', errMsg];
        }

        if (!errMsg) {
             //  console.log("!!! Clearing any previous error messages");
            setErrorMessage(null);
        }

        function hasEmptyParentheses(statement) {

            if (/^\(\s*\)$/.test(statement)) {
                return false;
            }
             //  console.log("!!! Checking for empty parentheses in:", statement);
            const contentParenthesesRegex = /\([^()]*[^()\s][^()]*\)/g;  // NOSONAR
            let reducedStatement = statement;

            while (contentParenthesesRegex.test(reducedStatement)) {
                reducedStatement = reducedStatement.replace(contentParenthesesRegex, '');
                 //  console.log("!!! Reduced statement after removing filled parentheses:", reducedStatement);
            }

            const emptyParenthesesRegex = /\(\s*\)/;
            const hasEmpty = emptyParenthesesRegex.test(reducedStatement);
             //  console.log("!!! Has empty parentheses?", hasEmpty);
            return hasEmpty;
        };

        if (hasEmptyParentheses(result.ConditionalStatement)) {
            errMsg = "Please remove empty rulegroups or add rules in the rulegroups!";
             //  console.log("!!! Empty rule groups detected. Error:", errMsg);
            setErrorMessage(errMsg);
            return ['error', errMsg];
        }

         //  console.log("!!! Final result to return:", result);
        return [result];
    };





































































































































    const initialValue = classificationData?.[0].DefaultValues[0].SchemeFilterClassification;
    const tableName = classificationData?.[0]?.TableName;



    useEffect(() => {

         //  console.log("INITIAL VALUES: ", initialValue, tableName);
         //  console.log("TRUE FALSE: ", initialValue && tableName && !initialQuery.rules.length > 0);
        if (initialValue && tableName && !initialQuery.rules.length > 0) {
            setSelectedClassification(initialValue || null);

            setInitialQuery({
                "combinator": "and",
                "rules": [
                    {
                        "field": `${tableName}-${initialValue}`,
                        "operator": "IN",
                        "valueSource": "value",
                        "value": null
                    }
                ]
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classificationData]);



    useEffect(() => {
        if (prevTabValue.name === 'Retailer') {
            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const formDataSave = async () => {

        // setLoading(true)
        try {

            let retailerData;

            const details = newQueryFormat(generatedQuery);
            if (details[0] === 'error') {
             

                retailerData = 'error' // NOSONAR

                return;
            }
            if (Array.isArray(details) && details.length > 0) {
                const vals = Object.values(details[0])[0];
                if (!vals.length > 0) {
                    setErrorMessage("Please select at least one value");

                    retailerData = 'error' // NOSONAR


                    return;
                }
            }

     
            console.log('warn query 1 ', details);
            let Retailer;
            if (details.length > 0) {
                Retailer = {
                    FilterType: "Retailer",
                    Details: details,
                };
            }


            const payload = schemeDetails;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;


            if (details.length > 0) {
                payload.Retailer = Retailer;

                retailerData = Retailer;
            } else {

                retailerData = [];


            }

            setRetailerData(retailerData);


        } catch (err) {


             //  console.log("Err: ", err);
        }


    }



    async function saveData() {


        // setLoading(true)
        try {

            let retailerData;

            const details = newQueryFormat(generatedQuery);
            if (details[0] === 'error') {
                

                retailerData = 'error'  // NOSONAR

                return;
            }
            if (Array.isArray(details) && details.length > 0) {
                const vals = Object.values(details[0])[0];
                if (!vals.length > 0) {
                    setErrorMessage("Please select at least one value");

                    retailerData = 'error' // NOSONAR


                    return;
                }
            }

   
            console.log('warn query 2 ', details);

            let Retailer;
            if (details.length > 0) {
                Retailer = {
                    FilterType: "Retailer",
                    Details: details,
                };
            }


            const payload = schemeDetails;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;


            if (details.length > 0) {
                payload.Retailer = Retailer;

                retailerData = Retailer;
            } else {

                retailerData = null;


            }

             //  console.log("retailerData: ", retailerData);
            setRetailerData(retailerData);
            try {
                if (isCopyScheme) {
                    const result = await addScheme(); // NOSONAR
                } else {

                    const result = await updateScheme(); // NOSONAR
                }
            } catch (err) {
                // handle error
            }

        } catch (err) {


             //  console.log("Err: ", err);
        }



    }



    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%', // Make sure parent takes full height
        }}>
            <FormProvider >
                <div

                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        minHeight: 0, // Enables child to grow correctly inside a flex container
                    }}
                >
                    {/* Scrollable content */}
                    <div style={{
                        flexGrow: 1,
                        overflow: 'auto', // enable vertical scroll
                        minHeight: 0,
                        maxHeight: '100%', // or set a custom height if needed
                    }}>

                        <div style={{ flexGrow: 1, minHeight: 0, overflow: 'auto' }}>
                            <QueryBuilder
                                fields={fields}
                                operators={operatorOptions}
                                combinators={combinators}
                                controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
                                controlElements={{
                                    combinatorSelector: ({ handleOnChange, value }) => (  // NOSONAR 
                                        <Select
                                            value={value}
                                            onChange={(e) => handleOnChange(e.target.value)}
                                            size="small"
                                            style={{ height: 30, overflow: 'visible' }}
                                            label='Combinator'
                                            sx={{ fontSize: '13px' }}
                                        >
                                            {combinators.length > 0 ? (
                                                combinators.map((combinator) => (
                                                    <MenuItem key={combinator.name} value={combinator.name} sx={{ fontSize: '13px' }}>
                                                        {combinator.label}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled sx={{ fontSize: '13px' }}>
                                                    No Options
                                                </MenuItem>
                                            )}
                                        </Select>
                                    ),
                                    fieldSelector: ({ handleOnChange, value, path, schema }) => {  // NOSONAR



                                        // Traverse using query
                                        let parent = initialQueryRef.current;
                                        // eslint-disable-next-line no-plusplus
                                        for (let i = 0; i < path.length - 1; i++) {
                                            parent = parent.rules[path[i]];
                                        }

                                        const siblingFieldNames = parent.rules?.map(item => item?.field);



                                        return (
                                            <FormControl sx={{ width: '45%' }} size='small'>
                                                <Autocomplete
                                                    value={value}
                                                    onChange={(event, newValue) => {
                                                        handleOnChange(newValue);
                                                        // Update selectedClassification when field changes
                                                        const selectedField = fields.find(f => f.name === newValue);
                                                        setSelectedClassification(selectedField ? selectedField.label : null);
                                                    }}
                                                    getOptionDisabled={option => siblingFieldNames.includes(option)}

                                                    options={fields?.map((field) => field.name)}
                                                    getOptionLabel={(option) => fields?.find(f => f.name === option)?.label || ''}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            size="small"
                                                            fullWidth
                                                            sx={{
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '13px',  // Set text size to 13px
                                                                },
                                                                '& .MuiFormLabel-root': {
                                                                    fontSize: '14px',  // Set label text size to 14px
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    // eslint-disable-next-line no-shadow
                                                    renderOption={(props, option) => (
                                                        <li
                                                            {...props}
                                                            style={{ fontSize: '13px' }} // Set font size for dropdown options
                                                        >
                                                            {fields.find(f => f.name === option)?.label || option}
                                                        </li>
                                                    )}
                                                    ListboxProps={{
                                                        style: {
                                                            maxHeight: '224px',
                                                            '& .MuiAutocomplete-option': {
                                                                fontSize: '13px',  // Set the font size for the options
                                                            },
                                                        },
                                                    }}
                                                    disableClearable
                                                    noOptionsText="No Options"
                                                />
                                            </FormControl>
                                        )
                                    },
                                    operatorSelector: ({ handleOnChange, value }) => ( // NOSONAR
                                        <FormControl style={{ width: '250px' }}>
                                            {/*
                                    <InputLabel size='small' style={{ fontSize: '14px' }}>Operator</InputLabel>
*/}
                                            <Autocomplete
                                                value={value}
                                                onChange={(event, newValue) => handleOnChange(newValue)}
                                                options={operatorOptions.map((op) => op.name)}
                                                getOptionLabel={(option) => operatorOptions.find(op => op.name === option)?.label || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        fullWidth
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',  // Set text size to 13px
                                                            },
                                                            '& .MuiFormLabel-root': {
                                                                fontSize: '14px',  // Set label text size to 14px
                                                            },
                                                        }}
                                                    />
                                                )}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '224px',
                                                        '& .MuiAutocomplete-option': {
                                                            fontSize: '13px',  // Set the font size for the options
                                                        },
                                                    },
                                                }}
                                                noOptionsText="No Options"
                                                disableClearable
                                            />
                                        </FormControl>
                                    ),
                                    // Inside the QueryBuilder control elements

                                    valueEditor: RetailerValueEditor,


                                    addRuleAction: ({ handleOnClick, rules }) => {  // NOSONAR
                                        const usedFields = getUsedFieldsInGroup(rules);
                                        const allFieldsUsed = Array.isArray(fields) && fields.length > 0
                                            ? fields.every(f => usedFields.has(f.name))
                                            : false;

                                        return (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleOnClick}
                                                style={{ marginRight: 8, height: '25px', padding: '5px' }}
                                                size="small"
                                                disabled={allFieldsUsed}
                                            >
                                                Add Rule
                                            </Button>
                                        );
                                    },

                                    addGroupAction: ({ handleOnClick }) => ( // NOSONAR
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleOnClick}
                                            style={{ marginRight: 8, height: '25px', padding: '5px' }}
                                            size="small"
                                        >
                                            Add RuleSet
                                        </Button>
                                    ),
                                    removeRuleAction: ({ handleOnClick }) => ( // NOSONAR
                                        <IconButton onClick={handleOnClick} size="small">
                                            <ClearIcon sx={{ color: 'red', height: '16px', width: '16px' }} />
                                        </IconButton>
                                    ),
                                    removeGroupAction: ({ handleOnClick }) => ( // NOSONAR
                                        <IconButton onClick={handleOnClick} size="small">
                                            <ClearIcon sx={{ color: 'red', height: '16px', width: '16px' }} />
                                        </IconButton>
                                    ),
                                }}
                                query={initialQuery}
                                onAddRule={onAddRule}
                                onQueryChange={handleQueryChange}
                            />
                        </div>



                    </div>

                    {/* Divider */}
                    <Divider sx={{ mt: 2 }} />

                    {/* Save button fixed at the bottom */}
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        {
                            errorMessage && (
                                <span style={{ color: 'red', fontSize: '10px', marginRight: '1rem' }}>{errorMessage}</span>
                            )
                        }
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                            alignItems="center"
                            sx={{ padding: '2px' }}
                        >
                            {schemeDetails?.SchemeLock !== true && canSaveScheme && (
                                <Tooltip title="Save">
                                    <IconButton type="button" onClick={() => saveData()} sx={{
                                        bgcolor: '#43b5a2',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '31px',
                                        padding: '4px',
                                    }}>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>


                    {initialLoading.current && <LoadingProgressBar />}


                </div>

            </FormProvider>
        </div>


    );
};

export default SchemeRetailer


